<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          :text="site.menu_blog_text"
          :redirect_name="redirect_name"
        />
      </v-col>
    </v-row>

    <v-container class="pt-0 mt-2">
      <v-row class="mt-1">
        <v-col
          v-for="(item, index) in dataItems"
          :key="index"
          class="px-2 py-2"
          cols="6"
          sm="4"
          lg="2"
          md="3"
        >
          <div>
            <v-card
              class="rounded-lg pa-3 card-container"
              outlined
              elevation="1"
              width="100%"
              style="border: none"
              @click="redirectTo(item)"
            >
              <v-img
                :cover="true"
                :aspect-ratio="1"
                width="100%"
                lazy-src="https://picsum.photos/id/11/100/100"
                :src="item.image"
              >
              </v-img>

              <p
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                v-snip="{ lines: 2 }"
              >
                {{ item.title }}
              </p>
              <p
                class="title-mission text-start mb-auto text-caption black--text"
                v-snip="{ lines: 2 }"
              >
                {{ item.sub_title }}
              </p>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div v-if="!dataItems.length">
      <v-img
        class="white--text mx-auto mt-10 empty"
        :src="require('@/assets/images/out-of-stock.png')"
        max-width="200px"
      >
      </v-img>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>
    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import HeaderTextBg from "@/components/headerTextBg.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    InfiniteLoading,
    HeaderTextBg,
  },
  data() {
    return {
      dataItems: [],
      infiniteId: +new Date(),
      redirect_name: "main",
    };
  },

  mounted() {},

  methods: {
    redirectTo(item) {
      this.$router.push({
        name: "blog",
        params: { id: item.id },
      });
    },
    infiniteHandler($state) {
      this.isAppLoading(true);
      Axios.get("site/getBlog", {
        params: {
          cursor: this.next_page_url,
        },
      })
        .then(({ data }) => {
          if (data.data.length) {
            let has_more = data.has_more;
            this.dataItems = this.dataItems.concat(data.data);
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
  },
  created() {},
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
};
</script>

<style scoped>
.v-btn__content {
  display: flex;
  flex-direction: column;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 80px;
  min-width: 95px;
  border-radius: 10px;
}

.bar-image {
  height: 210px;
  font-size: 14px;
}

.v-btn-toggle--group > .v-btn.v-btn {
  background-color: white !important;
  border-color: transparent;
}
.v-btn--absolute.v-btn--top,
.v-btn--fixed.v-btn--top {
  top: 3px;
}
.v-btn--absolute.v-btn--right,
.v-btn--fixed.v-btn--right {
  right: 5px;
}

.v-slide-group__content {
  justify-content: start !important;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}
.btn-close {
  position: absolute;
  margin-bottom: -100px;
  z-index: 888;
  right: 0;
}
.empty {
  opacity: 0.5;
}
</style>

<style scoped>
.card-container {
  position: relative;
  aspect-ratio: 1 / 1.5;
}
.disabled-card {
  /* background-color: #00000033; */
}

.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}

.container1 {
  position: relative;
}
.btn-close {
  position: absolute;
  margin-bottom: -100px;
  z-index: 888;
  right: 0;
}

.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  /* background-color: #00000099; */
  /* background-color: #FFFFFF99; */
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  /* color: #FFFFFF; */
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 0px 0px 72px 0px;
}
</style>
